import { Component, OnInit, SimpleChanges, Input, ElementRef, ViewChild, HostListener } from '@angular/core';
import { GlobalSearchService } from '../Services/global-search.service';
import { SearchResults, SearchContent, SCREEN_SIZE, FilterFacetItem, DateRangeFacetItem, TermFacetItem } from '../Models/common.model';
import { paginate } from '../Models/common.pagination';
import * as Global from "../Models/constants";

@Component({
    selector: 'global-search',
    templateUrl: './global-search.component.html',
    styles: [],
    providers: [GlobalSearchService]
})
export class GlobalSearchComponent implements OnInit {
    @Input() public loadingMessage: string;

    page = 1;
    pageSize = 10;
    maxPages = 10;
    startIndex: number;
    endIndex: number;
    pager: any = {};
    isLoading: boolean = true;
    searchQuery: string;
    searchTag: string;
    size: SCREEN_SIZE;
    @ViewChild('facet') facetDiv: ElementRef;
    @ViewChild('fromDate') startDateinput: ElementRef;
    @ViewChild('toDate') endDateinput: ElementRef;
    contentTypes: FilterFacetItem[] = [];
    dateRange: DateRangeFacetItem[] = [];
    authorTerms: TermFacetItem[] = [];
    categoryTerms: TermFacetItem[] = [];
    dateErrorMessage: string = Global.dateRangeErrorMessage;
    isValidDate: boolean = true;
    startDate: any;
    endDate: any;
    showMore: string = Global.showMore;
    showLess: string = Global.showLess;
    showAll: string = Global.showAll;
    minShownCount: number = 4; // items always shown in the author and category lists, and added per Show More
    maxShowMoreCount: number = 12; // after this many, Show More becomes Show All
    authorsShown: number = 4;
    categoriesShown: number = 4;
    isMobileFilter: boolean = false;
    sortOrder: string = "rel" // Default sort order Relevance.
    sortByLabel = "Order by "
    prefix = 'is-';
    origin = window.location.origin;
    sizes = [
        {
            id: SCREEN_SIZE.XS, name: 'xs', css: `d-block d-sm-none`
        },
        {
            id: SCREEN_SIZE.SM, name: 'sm', css: `d-none d-sm-block d-md-none`
        },
        {
            id: SCREEN_SIZE.MD, name: 'md', css: `d-none d-md-block d-lg-none`
        },
        {
            id: SCREEN_SIZE.LG, name: 'lg', css: `d-none d-lg-block d-xl-none`
        },
        {
            id: SCREEN_SIZE.XL, name: 'xl', css: `d-none d-xl-block`
        },
    ];

    @HostListener("window:resize", [])
    private onResize() {
        this.detectScreenSize();
    }

    ngAfterViewInit() {
        this.detectScreenSize();
    }

    encodeQuery(query: string): string {
        return encodeURIComponent(query);
    }


    private detectScreenSize() {
        const currentSize = this.sizes.find(x => {
            // get the HTML element
            const el = this.elementRef.nativeElement.querySelector(`.${this.prefix}${x.id}`);

            // check its display property value
            const isVisible = window.getComputedStyle(el).display != 'none';

            if (!isVisible) {
                return false;
            }
            else {
                return isVisible;
            }
        });

        this.dataService.onResize(currentSize.id);
    }

    constructor(public dataService: GlobalSearchService, private elementRef: ElementRef) {
        // subscribe to the size change stream
        this.dataService.onResize$.subscribe(x => {
            this.size = x;
            if (this.size == 2 || this.size == 3 || this.size == 4) {
                if (this.facetDiv.nativeElement.classList.contains('overlay')) {
                    this.facetDiv.nativeElement.classList.remove("overlay");
                    this.facetDiv.nativeElement.classList.add("d-none");
                }
            }
        });
    }

    ngOnInit(): void {
        this.peformSearch();

        this.dataService.getStaticData().subscribe((data: string) => {
            this.loadingMessage = data;
        })
    }

    private _searchResults: SearchResults<SearchContent>;
    get searchResults(): SearchResults<SearchContent> {
        return this._searchResults;
    }
    set searchResults(value: SearchResults<SearchContent>) {
        this._searchResults = value;
    }

    ngOnChanges(changes: SimpleChanges) {
        // reset page if items array has changed
        if (changes.items.currentValue !== changes.items.previousValue) {
            this.onChangePage(this.page);
        }
    }

    peformSearch(): void {
        this.isLoading = true;
        if (this.contentTypes.length > 0 || this.dateRange.length > 0 || this.authorTerms.length > 0 || this.categoryTerms.length > 0) {
            if (this.startDate != undefined && this.endDate != undefined) {
                this.ValidateDateRange(this.startDate, this.endDate)
            }
            if (this.isValidDate) {
                var filters = {};
                if (this.contentTypes.length > 0) {
                    filters["ContentType"] = this.contentTypes.map(i => i.Value);
                }
                if (this.authorTerms.length > 0) {
                    filters["Authors"] = this.authorTerms.map(i => i.Value);
                }
                if (this.startDate != undefined) {
                    filters["StartDate"] = this.startDate;
                }
                if (this.endDate != undefined) {
                    filters["EndDate"] = this.endDate;
                }
                if (this.categoryTerms.length > 0) {
                    filters["Categories"] = this.categoryTerms.map(i => i.Value);
                }

                this.DisableCheckboxes(true);
                this.dataService.getSearchResultFacet(this.page, filters, this.sortOrder).subscribe((data: SearchResults<SearchContent>) => {
                    this.pageSize = data.PageSize;
                    this.searchResults = data;
                    this.setPage(this.searchResults);
                    this.isLoading = false;
                    this.DisableCheckboxes(false);

                    this.searchResults.ContentTypesFilterFacets.forEach(type => {
                        let existsContentType = this.contentTypes.find((val) => val.Value === type.Value)
                        if (existsContentType) {
                            type.checked = true;
                        }
                    })

                    this.searchResults.DateRangeFacets.forEach(date => {
                        let existsDate = this.dateRange.find((val) => (val.DisplayName === date.DisplayName && val.checked === true))
                        if (existsDate) {
                            date.checked = true;
                        }
                    })

                    this.searchResults.AuthorsTermFacets.forEach(Author => {
                        let existsAuthor = this.authorTerms.find((val) => val.Value === Author.Value)
                        if (existsAuthor) {
                            Author.checked = true;
                        }
                    })

                    this.searchResults.CategoriesTermFacets.forEach(category => {
                        let existscategory = this.categoryTerms.find((val) => val.Value === category.Value)
                        if (existscategory) {
                            category.checked = true;
                        }
                    })
                    window.location.href = "#topofbody";
                })
            }
        }
        else {
            this.dataService.getSearchResults(this.page, this.sortOrder).subscribe((data: SearchResults<SearchContent>) => {
                this.pageSize = data.PageSize;
                this.searchResults = data;
                this.setPage(this.searchResults);
                this.isLoading = false;

                window.location.href = "#topofbody";
            })
        }
    }

    DisableCheckboxes(disable: boolean) {
        this.setAttribute(this.elementRef.nativeElement.querySelectorAll("[name='category']"), "disabled", disable);
        this.setAttribute(this.elementRef.nativeElement.querySelectorAll("[name='author']"), "disabled", disable);
        this.setAttribute(this.elementRef.nativeElement.querySelectorAll("[name='contentType']"), "disabled", disable);
        this.setAttribute(this.elementRef.nativeElement.querySelectorAll("[name='date']"), "disabled", disable);
    }

    public setAttribute(element, attr, val): void {
        if (element != null) {
            for (var item = 0; item < element.length; item++) {
                {
                    element[item].setAttribute(attr, val);
                }
            }
        }
    }

    onChangePage(pageIndex: any) {
        this.peformSearch();
    }

    setPage(searchResults: SearchResults<SearchContent>) {
        this.pager = paginate(searchResults.TotalMatching, this.page, this.pageSize, this.maxPages);

        //set nnumber of items per pages.
        this.startIndex = this.pager.startIndex + 1;
        this.endIndex = this.pager.endIndex + 1;
    }

    openFacet() {
        this.isMobileFilter = true;
        var facetDiv = this.facetDiv.nativeElement;
        if (!facetDiv.classList.contains('overlay')) {
            facetDiv.classList.add("overlay");
            facetDiv.style.display = "block";
            facetDiv.classList.remove("d-none");
            document.querySelector("body").setAttribute("style", "overflow:hidden");
        }
    }

    closeFacet() {
        if (this.isValidDate) {
            this.peformSearch();
            var facetDiv = this.facetDiv.nativeElement;
            if (facetDiv.classList.contains('overlay')) {
                facetDiv.classList.remove("overlay");
                facetDiv.style.display = "none";
                facetDiv.classList.add("d-none");
                document.querySelector("body").setAttribute("style", "overflow:none ");
            }
        }
    }

    // check if any filter is applied, so the filters stay visible (and can be cleared) when they leave no results
    hasActiveFilters(): boolean {
        return this.contentTypes.length > 0 || this.authorTerms.length > 0 || this.categoryTerms.length > 0 || !!this.startDate || !!this.endDate;
    }

    // check if the item are selected
    checked(item) {
        if (item != undefined) {
            if (this.contentTypes.indexOf(item) != -1) {
                return true;
            }
        }
    }

    toggleCheck(event, item) {
        this.page = 1;
        var facetType = event.target["attributes"]["name"].value;
        switch (facetType) {
            case "contentType":
                this.filterOnCheck(event, item, this.contentTypes)
                break;
            case "author":
                this.filterOnCheck(event, item, this.authorTerms)
                break;
            case "category":
                this.filterOnCheck(event, item, this.categoryTerms)
                break;
            case "date":
                this.dateRange = [];
                if (item.DisplayName == "Date Range") {
                    this.startDate = item.StartDate;
                    this.endDate = item.EndDate;
                    this.startDateinput.nativeElement.disabled = false;
                    this.endDateinput.nativeElement.disabled = false;
                    this.startDateinput.nativeElement.value = item.StartDate;
                    this.endDateinput.nativeElement.value = item.EndDate;
                    this.filterOnCheck(event, item, this.dateRange);
                    this.dateRange.map(date => { if (date.DisplayName == item.DisplayName) { date.checked = true; } })
                } else {
                    this.startDate = item.StartDate;
                    this.endDate = item.EndDate;
                    this.startDateinput.nativeElement.disabled = true;
                    this.endDateinput.nativeElement.disabled = true;
                    this.startDateinput.nativeElement.value = "";
                    this.endDateinput.nativeElement.value = "";
                    this.filterOnCheck(event, item, this.dateRange);
                    this.dateRange.map(date => { if (date.DisplayName == item.DisplayName) { date.checked = true; } })
                }
                break;
            default:
                break;
        }
    }

    filterOnCheck(event, item, type) {
        const index = type.findIndex(i => i.Value == item.Value);
        if (event.target.checked) {
            type.push(item);
        }
        else {
            type.splice(index, 1)
        }
        if (!this.isMobileFilter) {
            this.peformSearch();
        }
    }

    sortChange(event) {
        this.page = 1;
        let selectedOptions = event.target['options'];
        let selectedIndex = selectedOptions.selectedIndex;
        this.sortOrder = selectedOptions[selectedIndex].value;
        this.peformSearch();
    }

    onCalenderchange(event: any) {
        this.page = 1;
        this.isValidDate = true;
        let controlName = event.target["name"];
        let controlValue = event.target["value"];

        if (controlName == "StartDate") {
            if (this.startDate != controlValue) {
                this.startDate = controlValue;
                this.dateRange.forEach(date => { if (date.DisplayName == "Date Range") { date.StartDate = controlValue; } })
                this.ValidateDateRange(this.startDate, this.endDate);
                this.peformSearch();
            }
        }
        if (controlName == "EndDate") {
            if (this.endDate != controlValue) {
                this.endDate = controlValue;
                this.dateRange.forEach(date => { if (date.DisplayName == "Date Range") { date.EndDate = controlValue; } })
                this.ValidateDateRange(this.startDate, this.endDate);
                this.peformSearch();
            }
        }
    }

    ValidateDateRange(startDate, endDate) {
        if (new Date(startDate.replace(/-/g, "/")) > new Date(endDate.replace(/-/g, "/"))) {
            this.isValidDate = false;
        }
        else {
            this.isValidDate = true;
        }
    }

    // Show More / Show All / Show Less for the author and category lists. Worked out from how many items are shown and the current
    // list length (not from the rendered checkboxes or the link text), so it stays right when a filter changes the list.
    toggleShowMore(list: string) {
        if (list == "author") {
            this.authorsShown = this.nextShownCount(this.authorsShown, this.searchResults.AuthorsTermFacets.length);
        }
        if (list == "category") {
            this.categoriesShown = this.nextShownCount(this.categoriesShown, this.searchResults.CategoriesTermFacets.length);
        }
    }

    // Show More adds 4 items, up to 12; Show All shows the rest; Show Less goes back to the first 4
    nextShownCount(shown: number, total: number): number {
        if (shown >= total) {
            return this.minShownCount;
        }

        return shown >= this.maxShowMoreCount ? total : shown + this.minShownCount;
    }

    showMoreText(shown: number, total: number): string {
        if (shown >= total) {
            return this.showLess;
        }

        return shown >= this.maxShowMoreCount ? this.showAll : this.showMore;
    }
}
